/**
 * Role color & label constants. Centralized so the same palette is used by
 * the profile dropdown badge, the user management table, and any future
 * admin UI that needs to color-code roles.
 */
import type { UserRole } from '../contexts/UserContext';

export const ROLE_COLORS: Record<UserRole, string> = {
  admin: '#7c3aed',
  editor: '#1677ff',
  viewer: '#8c8c8c',
};

/** Antd Tag color names (mapped 1:1 with the hex codes above). */
export const ROLE_TAG_COLORS: Record<UserRole, string> = {
  admin: 'purple',
  editor: 'blue',
  viewer: 'default',
};

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
};
